/* 「現在の見出し」バー + 見出し一覧パネル。
 *
 * カリキュラム版(assets/curriculum-list.js の .shoppy-current-heading)と同じ体験を、
 * 無限スクロールのある まんが記事で成り立たせる。あちらとの違いは2つ:
 *
 *   1. 記事が**あとから増える**。DOM を先読みして NodeList を握ると、追記された
 *      話の見出しを永久に見落とす。毎回 querySelectorAll で引き直す。
 *   2. 追跡する単位が「1ページの節」でなく「いま読んでいる話の中の見出し」。
 *      話が変わったら一覧も差し替える。
 *
 * gp-manga.js とは**独立**。あちらの IntersectionObserver の発火順に依存しないよう、
 * スクロール監視は自前で持つ(あちらへ手を入れると、実測117pxずれの原因になった
 * 位置補正の順序を触ることになる)。
 */
(function () {
  "use strict";

  var ROOT_SEL = "[data-gp-manga-article]";
  var ENTRY_SEL = "[data-hta-entry]";
  var HEADING_SEL = ".gp-manga h2, .gp-manga h3";
  /* 読み取り線。ここを跨いだ見出しを「現在」とみなす。sticky バーの高さぶん下げる。 */
  var READ_LINE = 96;

  var root = document.querySelector(ROOT_SEL);
  if (!root) return;

  var bar = root.querySelector("[data-gpm-toc]");
  var barText = root.querySelector("[data-gpm-toc-text]");
  var panel = root.querySelector("[data-gpm-toc-panel]");
  var overlay = root.querySelector("[data-gpm-toc-overlay]");
  var list = root.querySelector("[data-gpm-toc-list]");
  var button = root.querySelector("[data-gpm-toc-button]");
  var closeButton = root.querySelector("[data-gpm-toc-close]");
  if (!bar || !barText || !panel || !overlay || !list || !button || !closeButton) return;

  var headingSeq = 0;
  var currentEntry = null;
  var currentHeading = null;
  var headings = [];

  /* ── 見出しの収集 ── */

  function ensureId(heading) {
    if (!heading.id) {
      headingSeq += 1;
      heading.id = "gpm-h-" + headingSeq;
    }
    return heading.id;
  }

  function text(node) {
    return (node.textContent || "").replace(/\s+/g, " ").trim();
  }

  /* いま読んでいる話。読み取り線を含む entry。無ければ先頭。 */
  function activeEntry() {
    var all = Array.prototype.slice.call(root.querySelectorAll(ENTRY_SEL));
    if (!all.length) return null;
    var found = null;
    all.forEach(function (entry) {
      var box = entry.getBoundingClientRect();
      if (box.top <= READ_LINE && box.bottom > READ_LINE) found = entry;
    });
    return found || (all[0].getBoundingClientRect().top > READ_LINE ? all[0] : all[all.length - 1]);
  }

  function collect(entry) {
    /* 空見出し(本文末尾に出ることがある)は落とす。押しても行き先が分からないため。 */
    return Array.prototype.slice.call(entry.querySelectorAll(HEADING_SEL))
      .filter(function (heading) { return text(heading) !== ""; });
  }

  /* ── 一覧パネルの中身 ── */

  function buildList() {
    list.textContent = "";
    headings.forEach(function (heading) {
      var item = document.createElement("li");
      item.className = "gpm-toc__item";
      if (heading.tagName.toLowerCase() === "h3") item.className += " gpm-toc__item--sub";
      item.setAttribute("data-target", ensureId(heading));

      var hit = document.createElement("button");
      hit.type = "button";
      hit.textContent = text(heading);
      item.appendChild(hit);
      list.appendChild(item);
    });
  }

  function markCurrent() {
    var id = currentHeading ? currentHeading.id : "";
    Array.prototype.forEach.call(list.children, function (item) {
      item.classList.toggle("gpm-toc__item--current", item.getAttribute("data-target") === id);
    });
  }

  /* ── 開閉 ── */

  function open() {
    markCurrent();
    panel.hidden = false;
    overlay.hidden = false;
    button.setAttribute("aria-expanded", "true");
    closeButton.focus();
  }

  function close() {
    panel.hidden = true;
    overlay.hidden = true;
    button.setAttribute("aria-expanded", "false");
  }

  button.addEventListener("click", function () {
    if (panel.hidden) open(); else close();
  });
  overlay.addEventListener("click", close);
  closeButton.addEventListener("click", function () { close(); button.focus(); });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && !panel.hidden) { close(); button.focus(); }
  });

  list.addEventListener("click", function (event) {
    var item = event.target.closest(".gpm-toc__item");
    if (!item) return;
    var target = document.getElementById(item.getAttribute("data-target"));
    close();
    if (!target) return;
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY - READ_LINE + 8,
      behavior: "smooth"
    });
  });

  /* ── スクロール監視 ── */

  function update() {
    var entry = activeEntry();
    if (!entry) return;

    if (entry !== currentEntry) {
      currentEntry = entry;
      headings = collect(entry);
      currentHeading = null;
      buildList();
      /* 見出しが無い話では、バーごと隠す(空の帯を出さない)。 */
      bar.hidden = headings.length === 0;
      if (bar.hidden) { close(); return; }
    }
    if (!headings.length) return;

    /* 読み取り線を最後に跨いだ見出しが「現在」。1つも跨いでいなければ先頭。 */
    var found = headings[0];
    headings.forEach(function (heading) {
      if (heading.getBoundingClientRect().top <= READ_LINE) found = heading;
    });
    if (found !== currentHeading) {
      currentHeading = found;
      barText.textContent = text(found);
      if (!panel.hidden) markCurrent();
    }
  }

  /* rAF で間引く。スクロールのたびに getBoundingClientRect を数十回呼ぶため。 */
  var queued = false;
  function onScroll() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; update(); });
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  /* 追記・差し替えを拾う。gp-manga.js の完了イベントに依存しないための保険。
     監視は **main の直下だけ**(subtree なし)。gp-manga.js は entry を sentinel の
     手前 / head の手前へ入れるので、直下だけで足りる。subtree を付けると
     このスクリプト自身が一覧を組み直すたびに再発火して無駄に回る。 */
  var main = root.querySelector(".gp-manga-article__main") || root;
  new MutationObserver(onScroll).observe(main, { childList: true });

  update();
  window.addEventListener("load", update);
})();
